// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiListe.js
//  WikiListe
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { THEME } from "../../socle/theme";
import { wCat } from "./constantes";
import { wGhostSm, wInp, wPanel, wPur } from "./styles";

// ═══════════════ Liste d'une catégorie ═══════════════
export function WikiListe({ api, categorie, onRetour, onOuvrir, onNouvelle, droits }) {
  const [pages, setPages] = useState(null);
  const [filtre, setFiltre] = useState("");
  const [statut, setStatut] = useState("");
  const st = wCat(categorie);

  useEffect(() => {
    const qs = new URLSearchParams({ categorie });
    if (statut) qs.set("statut", statut);
    api.liste(qs.toString()).then(setPages).catch(() => setPages([]));
  }, [categorie, statut, api]);

  const visibles = (pages || []).filter((p) =>
    !filtre.trim() || `${p.titre} ${p.resume || ""} ${p.tags || ""}`.toLowerCase().includes(filtre.toLowerCase()));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <button onClick={onRetour} style={wGhostSm}>← Wiki</button>
        <h2 style={{ color: st.couleur, fontSize: 18, fontWeight: 800, margin: 0 }}>{st.icone} {st.label}</h2>
        <div style={{ flex: 1 }} />
        {droits.creer && <button onClick={() => onNouvelle(categorie)} style={wPur}>+ Nouvelle page</button>}
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input value={filtre} onChange={(e) => setFiltre(e.target.value)} placeholder="Filtrer…" style={{ ...wInp, maxWidth: 300 }} />
        <select value={statut} onChange={(e) => setStatut(e.target.value)} style={{ ...wInp, maxWidth: 190 }}>
          <option value="">Publiées et brouillons</option>
          <option value="publie">Publiées</option>
          <option value="brouillon">Brouillons</option>
          <option value="archive">Archivées</option>
          {droits.redacteur && <option value="corbeille">Corbeille</option>}
        </select>
      </div>

      {!pages && <div style={{ color: THEME.textMuted }}>Chargement…</div>}
      {pages && visibles.length === 0 && (
        <div style={{ ...wPanel, textAlign: "center", color: THEME.textMuted, fontSize: 13, padding: 40 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>{st.icone}</div>
          Aucune page dans cette catégorie pour l'instant.
        </div>
      )}
      {visibles.map((p) => (
        <div key={p.id} onClick={() => onOuvrir(p.slug)}
          onMouseEnter={(e) => (e.currentTarget.style.borderColor = THEME.purple)}
          onMouseLeave={(e) => (e.currentTarget.style.borderColor = THEME.border)}
          style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: "14px 18px", display: "flex", gap: 14, alignItems: "flex-start", cursor: "pointer" }}>
          <div style={{ fontSize: 20 }}>{p.epingle ? "📌" : p.statut === "brouillon" ? "📝" : "📄"}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <span style={{ color: THEME.text, fontWeight: 700, fontSize: 14.5 }}>{p.titre}</span>
              {p.statut === "publie" && <Badge text="publiée" bg={THEME.emeraldDim} color={THEME.emerald} />}
              {p.statut === "brouillon" && <Badge text="brouillon" bg={THEME.amberDim} color={THEME.amber} />}
              {p.statut === "archive" && <Badge text="archivée" bg={THEME.surface} color={THEME.textMuted} />}
              {p.statut === "corbeille" && <Badge text="corbeille" bg={THEME.redDim} color={THEME.red} />}
              {!!p.ia_assiste && <Badge text="🤖 assisté par IA" bg={THEME.purpleDim} color={THEME.purple} />}
              {!!p.verrouille && <Badge text="🔒" bg={THEME.amberDim} color={THEME.amber} />}
              {p.visibilite !== "guide" && <Badge text={`👁 ${p.visibilite}`} bg={THEME.accentDim} color={THEME.accent} />}{/* LISTE_VIS_GUIDE */}
            </div>
            {p.resume && <div style={{ color: THEME.textMuted, fontSize: 12.5, marginTop: 5 }}>{p.resume}</div>}
            <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 7 }}>
              {(p.tags || "").split(",").filter((t) => t.trim()).map((t) => `#${t.trim()}`).join(" ")}
              {p.tags ? " · " : ""}{p.editeur || p.auteur || "—"} · v{p.version} · {new Date(p.updated_at).toLocaleDateString("fr")} · {p.vues} vue{p.vues > 1 ? "s" : ""}
            </div>
          </div>
          <span style={{ color: THEME.textMuted, fontSize: 12, whiteSpace: "nowrap" }}>Ouvrir →</span>
        </div>
      ))}
    </div>
  );
}
